import React, { Component } from 'react';
 
class Header extends Component {
    render() {
        return (
            <div>Header</div>
            )
    }
}
export default Header;